export const IDLE_TIMEOUT_HOURS = 6;
export const IDLE_TIMEOUT_MS = IDLE_TIMEOUT_HOURS * 60 * 60 * 1000;
